module.exports = __webpack_public_path__ + "static/media/parents management.ab974172.svg";